
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Cabserviceinpune() {



    const cardData =
    {
        keyword: 'Cab Service in Pune',
        heading: 'Mauli Cabs: Cab Service in Pune',
        headingDescription: 'Mauli Cabs offers reliable cab services in Pune, providing comfortable, safe, and affordable transportation for all your travel needs. Whether you need a ride for business, leisure, family outings, or airport transfers, we have a fleet of well-maintained vehicles, including sedans, SUVs, and premium cabs, to suit your requirements. Our professional drivers ensure timely pick-ups and smooth rides across the city and beyond. With transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free travel experience in Pune.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a favorite spot for trekking and offers panoramic views and a rich historical background."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganesh temples in Maharashtra, this temple is revered for its magnificent idol and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Parvati Hill",
        "description": "Parvati Hill offers a serene temple complex atop a hill with beautiful views of the city and is one of the oldest heritage sites in Pune."
    },
    {
        "title": "Osho Garden and Ashram",
        "description": "Located in Koregaon Park, this peaceful garden and spiritual center draws global visitors for meditation and relaxation in tranquil surroundings."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum showcases a fascinating collection of artifacts, including musical instruments, weaponry, and antiques, celebrating India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by a Japanese design, this beautifully landscaped garden is perfect for calm walks and nature photography."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Also known as Katraj Zoo, this park houses various species of animals and a dedicated snake park, popular with families and kids."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, this ancient monument offers spiritual solace in the middle of the city."
    }
],

"services": [
    {
      "name": "Cab Booking in Pune",
      "description": "Book a cab in Pune for local and outstation travel, offering a wide range of vehicles like sedans, SUVs, and luxury cars."
    },
    {
      "name": "Outstation Cabs Pune",
      "description": "Rent cabs for outstation trips from Pune to popular destinations like Shirdi, Mumbai, Lonavala, and more with flexible pricing options."
    },
    {
      "name": "Cheapest Cab Service in Pune",
      "description": "Affordable and reliable cab services in Pune with budget-friendly rates for both local and outstation journeys."
    },
    {
      "name": "Taxi in Pune",
      "description": "Get reliable and comfortable taxi services in Pune for both short and long-distance travel."
    },
    {
      "name": "Innova on Rent Pune",
      "description": "Rent an Innova for a comfortable and spacious ride in Pune. Ideal for family trips and outstation travel."
    },
    {
      "name": "Best Cab Service in Pune",
      "description": "Choose the best-rated cab service in Pune for excellent customer experience, punctuality, and clean vehicles."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Book outstation taxis from Pune to nearby cities like Mumbai, Lonavala, Mahabaleshwar, and more with affordable rates and convenience."
    },
    {
      "name": "Online Cab Booking Pune",
      "description": "Easily book cabs online in Pune through our user-friendly platform for both local and outstation travel."
    },
    {
      "name": "Pune to Shirdi Car Rental",
      "description": "Rent a car from Pune to Shirdi for a spiritual journey, offering a variety of vehicles including sedans, SUVs, and more."
    },
    {
      "name": "Car Booking in Pune",
      "description": "Book cars for local sightseeing or outstation trips in Pune with options like sedan, SUV, and luxury vehicles."
    },
    {
      "name": "Pune Cabs",
      "description": "Affordable and convenient cabs for all your travel needs in Pune. Book cabs for local sightseeing or outstation trips."
    },
    {
      "name": "7 Seater Car on Rent in Pune",
      "description": "Rent a 7-seater car in Pune for group travel. Ideal for family trips and corporate events."
    },
    {
      "name": "Airport Taxi Pune",
      "description": "Book a taxi to and from Pune Airport for convenient and hassle-free airport transfers."
    },
    {
      "name": "Pune Airport Taxi Service",
      "description": "Reliable taxi services from Pune Airport, offering comfortable and timely rides to your desired destination."
    },
    {
      "name": "Innova Crysta Cabs",
      "description": "Rent the luxurious **Innova Crysta** for your travel in Pune, offering premium comfort for both local and outstation trips."
    }
  ],
  "tableData": [
    ["Cab Booking in Pune", "Outstation Cabs Pune"],
    ["Cheapest Cab Service in Pune", "Taxi in Pune"],
    ["Innova on Rent Pune", "Best Cab Service in Pune"],
    ["Outstation Taxi Service Pune", "Online Cab Booking Pune"],
    ["Pune to Shirdi Car Rental", "Car Booking in Pune"],
    ["Pune Cabs", "7 Seater Car on Rent in Pune"],
    ["Airport Taxi Pune", "Pune Airport Taxi Service"],
    ["Innova Crysta Cabs"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Cab Service in Pune",
        "WhyChoosedescription": "Mauli Cabs offers reliable and efficient cab services across Pune for all your travel needs. Whether it’s a quick city ride, airport transfer, or an outstation trip, we’ve got you covered with well-maintained vehicles and professional drivers."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles Available",
        "WhyChoosedescription": "Choose from a variety of vehicles including sedans, SUVs, Tempo Travellers, and premium options. Whether you're traveling solo or in a group, Mauli Cabs has the perfect ride for every occasion."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy clear and competitive rates with no hidden charges. Mauli Cabs ensures complete transparency in pricing, so you always know what you're paying for—no surprises."
    },
    {
        "WhyChooseheading": "Experienced and Verified Drivers",
        "WhyChoosedescription": "Our drivers are experienced, background-verified, and well-trained in customer service. They ensure your safety, punctuality, and a smooth journey every time you ride with us."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability in Pune",
        "WhyChoosedescription": "No matter the time or day, Mauli Cabs is available 24/7 for your convenience. Late-night rides, early-morning airport drops, or emergency travel—count on us anytime."
    },
    {
        "WhyChooseheading": "Easy Booking and Real-Time Tracking",
        "WhyChoosedescription": "Book your cab easily via our website or mobile app in just a few steps. Track your ride in real-time and receive updates for a stress-free travel experience."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and GPS-Enabled Cars",
        "WhyChoosedescription": "All our vehicles are regularly cleaned and sanitized. They are also GPS-enabled for real-time tracking and added safety, ensuring a hygienic and secure travel experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Mauli Cabs accepts multiple payment modes, including UPI, debit/credit cards, wallets, and cash—offering you a seamless and hassle-free booking experience."
    }
]











    }

    const faqData = [
        {
            question: 'How can I book a cab in Pune with Mauli Cabs?',
            answer: 'Booking a cab in Pune with Mauli Cabs is quick and convenient. Visit our website or use the mobile app, enter your pickup and drop location, choose your preferred vehicle type, and confirm your booking. You can also call our customer support for help with bookings.',
        },
        {
            question: 'What types of cabs are available with Mauli Cabs in Pune?',
            answer: 'Mauli Cabs offers a wide range of vehicles in Pune including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and luxury cars. You can select a vehicle based on your group size, luggage, and comfort preference.',
        },
        {
            question: 'Is the cab fare in Pune fixed with Mauli Cabs?',
            answer: 'Yes, Mauli Cabs provides transparent and fixed pricing. The fare includes fuel, tolls, driver charges, and taxes, with no hidden costs. The full fare is shown upfront before you confirm your ride.',
        },
        {
            question: 'Can I book a cab for local, outstation, or airport transfers in Pune?',
            answer: 'Yes, Mauli Cabs offers local city rides, airport transfers, and outstation trips from Pune. Whether it’s a short city ride or a long-distance journey, we have options to suit every travel need.',
        },
        {
            question: 'Is the cab service available 24/7 in Pune?',
            answer: 'Yes, our cab service in Pune operates 24/7. You can book a ride at any time of the day or night for airport transfers, early morning pickups, or late-night drop-offs.',
        },
        {
            question: 'Are Mauli Cabs drivers professional and trained?',
            answer: 'Yes, all our drivers are professionally trained, background-verified, and well-mannered. They ensure a safe, timely, and comfortable ride experience for all passengers.',
        },
        {
            question: 'Can I schedule a cab in advance in Pune?',
            answer: 'Absolutely. Mauli Cabs allows advance bookings so you can schedule your cab ahead of time and travel without any last-minute hassles.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arvind Kulkarni",
            position: "IT Consultant",
            text: "Mauli Cabs is my go-to for all my work travel in Pune. Their cabs are always on time, the drivers are polite, and the booking process is super simple. Great service every time!",
            image: "/img/testimonial/testimonial-thumb-1-111.png",
        },
        {
            name: "Ms. Sneha More",
            position: "Architect",
            text: "I’ve used Mauli Cabs for both city rides and outstation trips from Pune. They have clean vehicles and courteous drivers. Booking is easy, and prices are fair. Highly recommend their service!",
            image: "/img/testimonial/testimonial-thumb-1-112.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Cab Service in Pune",
        "description": "Book reliable and affordable cab services in Pune, including outstation taxis, airport transfers, and 7-seater rentals like Innova and Crysta for a comfortable ride.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "250"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.maulicabs.com/cab-service-in-pune",
          "priceCurrency": "INR",
          "price": "15",
          "priceValidUntil": "2025-12-31"
        }
      };
      
    
      


    return (
        <div>
            <GTag/>
  <Helmet>
        <title>Cab Service in Pune | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book affordable and reliable cab services in Pune. Get outstation cabs, airport taxis, and 7-seater rentals like Innova and Crysta for a comfortable ride. Online booking available."
        />
        <meta
          name="keywords"
          content="Cab service in Pune, outstation cabs Pune, taxi in Pune, innova on rent Pune, best cab service in Pune, airport taxi Pune, 7-seater car rental Pune, online cab booking Pune"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/139.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinpune;